import {GlobalVariables} from "../GlobalVariables";
import {ScrollTrigger, gsap} from "../LibrariesImport";
export default class PageSociety {
	static init() {

		if( !document.body.classList.contains('post-type-archive-society') ){
			return;
		}

		const swiper = document.querySelector('.swiper-nav-society');
		let swiperNav = new Swiper(swiper, {
			slidesPerView: "auto",
			grabCursor: true,
			spaceBetween: 10,
			navigation: {
				prevEl: '.swiper-nav-society-prev',
				nextEl: '.swiper-nav-society-next',
			}
		});

		const societyDetails = document.querySelectorAll('.society-detail');
		societyDetails.forEach( (detail, index) => {

			ScrollTrigger.create({
				trigger: detail,
				start: "top 25%",
				end : "bottom 25%",
				onEnter : () => {
					swiperNav.slideTo(index, 300, true);
					swiperNav.slides.forEach(slide => slide.classList.remove("swiper-slide-current"));
					swiperNav.slides[index].classList.add("swiper-slide-current");
				},
				onEnterBack : () => {
					swiperNav.slideTo(index, 300, true);
					swiperNav.slides.forEach(slide => slide.classList.remove("swiper-slide-current"));
					swiperNav.slides[index].classList.add("swiper-slide-current");
				}
			});

		});

	}

	static toggleNavigation(swiper, container, navigation){
		if (swiper.slides.length <= swiper.params.slidesPerView) {
			container.closest('.cursor-follower-inner').classList.add("swiper-disabled-follower");
			navigation.style.display = 'none';
		}else{
			container.closest('.cursor-follower-inner').classList.remove("swiper-disabled-follower");
			navigation.style.display = 'inline-flex';
		}
	}

}
